import React from 'react'
import { observer } from 'mobx-react'
import Button from 'components/Button'
import ConfirmAction from '../../../../../assets/images/img_confirm-action.svg'
import RejectDraftInReviewDialogViewModel from './RejectDraftInReviewDialogViewModel'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'

interface Props {
  vm: RejectDraftInReviewDialogViewModel
}

const RejectDraftDialog = observer(({ vm }: Props) => {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentIllustration src={ConfirmAction} />
        <ModalSheetContentBlock>
          <ModalSheetContentTitle>
            Do you want to request changes to your latest draft return?
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Please communicate with your Pro the changes you are requesting.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button type="secondary" onClick={vm.close}>
            Cancel
          </Button>
          <Button type="danger" onClick={vm.rejectDraft}>
            Request Changes
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})

export default RejectDraftDialog
